import type { SocialPlatform } from "@content-os/config";
import { eligibleFormats, type MediaDimensions, type PostType } from "@content-os/post-types";

export interface FormatPickerProps {
  platform: SocialPlatform;
  media: MediaDimensions | null;
  value: PostType | null;
  onChange: (postType: PostType | null) => void;
}

export function FormatPicker({ platform, media, value, onChange }: FormatPickerProps) {
  const choices = eligibleFormats(platform, media);
  if (choices.length <= 1) return null;

  const selected = choices.find((c) => c.postType === value) ?? choices[0];
  const showWarning = selected.isStory && selected.ratioStatus !== "match";

  return (
    <div className="space-y-1">
      <div className="flex gap-2">
        {choices.map((c) => {
          const isSelected = c.postType === value;
          return (
            <button
              key={c.postType ?? "default"}
              type="button"
              onClick={() => onChange(c.postType)}
              className={
                "rounded border px-3 py-1 text-sm " +
                (isSelected
                  ? "border-primary bg-primary/10 text-primary"
                  : "border-border text-muted-foreground")
              }
            >
              {c.label}
            </button>
          );
        })}
      </div>
      {showWarning && (
        <p className="text-xs text-amber-600">
          This video isn't 9:16 — it may be cropped or letterboxed in a Story.
        </p>
      )}
    </div>
  );
}
